import * as T from '../../../components/Table'

export function Item({ item }) {
  return (
    <T.Tr>
      <T.Td borderRight="1px solid #cfcfcf!important">{item.dt_mov}</T.Td>
      <T.Td borderRight="1px solid #cfcfcf!important">{item.nunota}</T.Td>
      <T.Td borderRight="1px solid #cfcfcf!important">{item.vendedor}</T.Td>
      <T.Td borderRight="1px solid #cfcfcf!important">{item.empresa}</T.Td>
      <T.Td borderRight="1px solid #cfcfcf!important">{item.valor}</T.Td>
      <T.Td borderRight="1px solid #cfcfcf!important">
        {item.tipo_pagamento}
      </T.Td>
      <T.Td>{item.dias_atraso}</T.Td>
    </T.Tr>
  )
}
